export var HEADER_HEIGHT = 76;
export var HEADER_HEIGHT_DESKTOP = 130;